








































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { POSProduct, POSProductType } from '@pos/interfaces/pos-v2';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import BpcPosContactForm from './pos-contact-form.vue';

@Component({
  name: 'bpc-pos-change-owner-modal',
  components: {
    BpcInput,
    'bpc-entity-select': EntitySelect,
    'bpc-pos-contact-form': BpcPosContactForm,
  },
})
export default class PosChangeOwner extends Vue {
  declare $refs: {
    contactSelect: InstanceType<typeof EntitySelect> & {
      getEntities(): void;
    };
  };
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly closeDisabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly confirmDisabled: boolean;
  @Prop({ type: Number }) readonly ticketId: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly posSessionId!: number;
  @Prop({
    type: Number,
  })
  readonly defaultContactId: number;
  @Prop({
    type: Object,
  })
  readonly product: POSProduct;
  @Prop({
    type: String,
  })
  readonly productType: POSProductType;
  // DATA
  badgeNumber = '';
  contactConfig = {
    fieldPath: 'contact',
    fieldReadPath: 'contact',
    name: 'contact',
    label: 'global.contact.label',
    options: [],
    id: 'contact-id',
    rules: [],
    selectLabel: 'fullname',
    selectEntity: 'contact',
    selectMultiple: false,
    selectValue: 'id',
    withNew: true,
  };
  contactId = 0;
  contactForm = null; // TODO type this : POSContact ?
  showContactCreationForm: boolean = false;
  contactCreationSaveActionPortalTarget: string = 'pos-contact-creation-save-action';
  isUserInitiated: boolean = false;

  // COMPUTED
  get accessControlActivated() {
    return this.$modulesService.hasModuleActivated('access_control');
  }

  get col10() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field': true,
        },
      },
    };
  }

  // METHODS
  async getBadgeForContact() {
    if (this.isUserInitiated) {
      const path = `${this.$bpcApiRouteHelper.getEntityPath('contact')}/${
        this.contactId
      }/get-primary-badge`;

      const res = await this.$bpcApi.get(path).toPromise();
      if (res.data) {
        this.isUserInitiated = false;
        this.badgeNumber = res.data['badge_number'];
      } else {
        this.badgeNumber = '';
      }
    } else {
      this.isUserInitiated = true;
    }
  }

  async getContactIfStopChanging(badgeNumber: string) {
    setTimeout(() => {
      if (badgeNumber === this.badgeNumber && this.accessControlActivated) {
        this.getContactForBadge();
      }
    }, 300);
  }

  async getBadgeIfStopChanging(contactId: number) {
    setTimeout(() => {
      if (contactId === this.contactId && this.accessControlActivated) {
        this.getBadgeForContact();
      }
    }, 300);
  }

  async onContactCreated(e) {
    console.log('onContactCreated', e.data);
    const contactId = e.data?.id;
    this.contactId = contactId;
    this.showContactCreationForm = false;
  }

  onNewPosButton() {
    this.showContactCreationForm = true;
  }

  async getBadgeForProduct() {
    const badgeNumber: string | undefined = await this.$posService.getBadgeForProduct(
      this.posSessionId,
      this.ticketId,
      this.product.id,
    );
    if (badgeNumber !== null) {
      this.badgeNumber = badgeNumber;
    } else {
      this.badgeNumber = '';
    }
  }

  async getContactForBadge() {
    if (this.isUserInitiated) {
      const path = `${this.$bpcApiRouteHelper.getEntityPath('access-control-badges')}`;
      const queryConfig = {
        params: {
          badge_number: this.badgeNumber,
          status: ['active', 'blocked'],
        },
      };
      const badge = await this.$bpcApi.get(path, queryConfig).toPromise();
      if (badge.data.length === 1) {
        this.isUserInitiated = false;
        this.contactId = badge.data[0].contact_id;
        await this.$nextTick();
        this.$refs.contactSelect.getEntities();
      }
    } else {
      this.isUserInitiated = true;
    }
  }

  closeModal() {
    this.$emit('close');
    this.badgeNumber = '';
  }

  async onConfirm() {
    const newTicketDetail = await this.$posService.changeProductOwner(
      this.posSessionId,
      this.ticketId,
      this.productType,
      this.product.id,
      this.contactId,
      this.badgeNumber,
    );
    this.closeModal();
    this.$emit('owner-changed', newTicketDetail);
  }

  // LIFECYCLE HOOKS

  // WATCHERS
  @Watch('contactId')
  onContactIdChange(contactId) {
    if (contactId) {
      this.getBadgeIfStopChanging(contactId);
    } else {
      this.badgeNumber = '';
    }
  }

  @Watch('badgeNumber')
  onChangeBadgeNumber(badgeNumber) {
    if (badgeNumber) {
      this.getContactIfStopChanging(badgeNumber);
    }
  }

  @Watch('showModal')
  onShowModal(showmodal: boolean) {
    if (showmodal) {
      this.contactId = this.defaultContactId;
      this.isUserInitiated = false;
      if (this.getBadgeForProduct) {
        this.getBadgeForProduct();
      }
    }
  }
}
